import React, { useState } from "react";
import ArrowRight from "../../assets/svg/ArrowRight";
import WalletFirst from "../../assets/svg/WalletFirst";
import useCoupon from "../../hooks/useCoupon";
import useCart from "../../hooks/useCart";
import useWallet from "../../hooks/useWallet";
import useLoader from "../../hooks/useLoader";
import axiosPrivate from "../../axios/axiosPrivate";
import BottomSheet from "../utils/BottomSheet";
import { useNavigate } from "react-router-dom";

const PayCod = ({ regularPrice, comparePrice, container, walletApplied }) => {
  const { cartData } = useCart();
  const { useWalletCredit } = useWallet();
  const { couponData } = useCoupon();
  const { setLoading } = useLoader();
  const navigate = useNavigate();

  const [confirmOpen, setConfirmOpen] = useState(false);

  const codPayment = async () => {
    try {
      const couponApplied = couponData?.applied;
      const couponCode = couponData?.appliedCoupon?.coupon_name;
      const cart = [];

      cartData?.items?.map((data) => {
        const isUpsell = data?.properties?.upsell_discount === "true";
        const upsellPrice = data?.properties?.upsell_price;
        cart?.push({
          variant_id: data?.variant_id,
          quantity: data?.quantity,
          original_price: data?.price,
          ...(isUpsell && upsellPrice && { price: upsellPrice }),
        });
      });

      const payload = {
        cart,
        couponApplied,
        couponCode,
        payment_method: "cod",
        osName: "WEB",
        useWallet: useWalletCredit,
      };

      setLoading(true);
      const response = await axiosPrivate.post("/orders/create-order", payload);
      const productIds = response?.data?.line_items.map(
        (item) => item.product_id
      );

      setLoading(false);
      navigate("/thank-you", {
        state: {
          orderStatusUrl: response?.data?.order_status_url,
          orderAmount: response?.data?.total_price,
          contentId: productIds || [],
        },
        replace: true,
      });

      // REDIRECT FOR SHOPIFY
      // window.parent.postMessage(
      //   {
      //     type: "REDIRECT_TO_URL",
      //     payload: response?.data?.order_status_url,
      //     orderAmount: response?.data?.total_price,
      //     contentId: productIds || [],
      //   },
      //   "*"
      // );
    } catch (error) {
      console.log(error?.response?.data || error?.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="py-4 flex justify-between items-start cursor-pointer hover:bg-gray-50"
        onClick={() => setConfirmOpen(true)}
      >
        <div className="flex items-start gap-2">
          <div className="border border-1 px-[4px] py-[4px]  border-gray-400 rounded-[4px]">
            <WalletFirst width={14} height={14} />
          </div>
          <div>
            <p className="text-[16px] supreme-medium">Cash on delivery</p>
            <div className="mt-2 flex items-center gap-1 bg-cod px-2 py-1 rounded-sm">
              <p className="text-[12px] general-sans-regular text-[#e95123]">
                Inc.
              </p>
              <p className="text-[12px] general-sans-medium text-[#e95123]">
                ₹150.00
              </p>
              <p className="text-[12px] general-sans-regular text-[#e95123]">
                COD charges
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-baseline gap-2">
            <p className="text-[16px] supreme-bold">
              ₹
              {Math.max(
                0,
                (couponData?.appliedCoupon?.discountAmount
                  ? regularPrice - couponData?.appliedCoupon?.discountAmount + 150
                  : Number(regularPrice) + 150) - (walletApplied || 0)
              ).toFixed(0)}
            </p>
          </div>
          <ArrowRight width={14} height={14} className="fill-gray-500" />
        </div>
      </div>
      <BottomSheet
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        container={container}
        title="Confirm your order"
      >
        <div className="p-4 space-y-3">
          <div className="flex items-center gap-x-2 gap-y-2 flex-wrap">
            <p className="text-[14px] supreme-bold">
              Total amount: ₹
              {couponData?.appliedCoupon?.discountAmount
                ? (
                    regularPrice -
                    couponData?.appliedCoupon?.discountAmount +
                    150
                  ).toFixed(0)
                : (Number(regularPrice) + 150).toFixed(0)}
            </p>
            <div className="danger-bg-label px-3 py-1 rounded-sm">
              <p className="text-[14px] general-sans-regular text-[#e95123]">
                Incl. ₹150.00 COD charges
              </p>
            </div>
          </div>
          <button
            className="w-full p-4 rounded-md bg-blue-500 text-white text-[14px] supreme-medium"
            onClick={() => {
              setConfirmOpen(false);
              codPayment();
            }}
          >
            Confirm & Place Order
          </button>

          <button
            className="w-full p-4 rounded-md border border-gray-400 text-[14px] supreme-medium"
            onClick={() => setConfirmOpen(false)}
          >
            Pay online (save upto ₹250)
          </button>
        </div>
      </BottomSheet>
    </>
  );
};

export default PayCod;
